"use client";
import { jsx } from "react/jsx-runtime";
import { cn } from "../../utils/cn.js";
import { scrimVariants } from "./Scrim.variants.js";
function Scrim({ children, className, isBottom = false, isTop = false, padding = 2, overhang }) {
    const classes = cn(scrimVariants({
        padding: padding,
        isTop: isTop,
        isBottom: isBottom,
        isFull: !isTop && !isBottom,
        overhang
    }), className);
    return /*#__PURE__*/ jsx("div", {
        className: classes,
        children: children
    });
}
export { Scrim };
